var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "container-image-wrapper" },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "container-image" }, [
          _c("img", {
            staticStyle: {
              "object-fit": "contain",
              width: "100%",
              height: "277px"
            },
            attrs: { src: require("../../assets/about-us.jpg") }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cda7d3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cda7d3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/aboutUsImage.vue
// module id = null
// module chunks = 